import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'js-cookie'
const initialState = {
   tokenUser:Cookies.get("token")?JSON.parse(Cookies.get("token")):""
};
export const TokenSlice = createSlice({
    name: "Token",
    initialState,
    reducers: {
        userTokenShow: (state,action) => {
            Cookies.set("token",JSON.stringify(action?.payload))
        },
    },
});
export const {
    userTokenShow
} = TokenSlice.actions;
export default TokenSlice.reducer;
